<div class="full-container">
    <div class="search-resource">
        <div class="search-bar">
            <p class="search-title">{{ labels.TYPE_RESOURCE }}</p>
            <div class="commands">
                <i class="fas fa-magnifying-glass search"></i>
                <input type="text" class="form-control" [(ngModel)]="resourceCode" (input)="findResource()"/>
            </div>
    
            <div class="resource-not-found" *ngIf="resourceStatus?.status === 'not_found'">
                {{ labels.RESOURCE_NOT_FOUND}}
            </div>
    
            <div class="image-data" *ngIf="resourceStatus?.type === 'image'">
                <div class="image-exists">
                    <p class="image-present">{{ labels.IMAGE_EXISTS }}</p>
                    <button mat-raised-button class="btn btn-primary refetch-ctrl" (click)="openExam(resourceStatus.exam_code)">Abrir exame</button>
                </div>
                
                <table
                mat-table
                [dataSource]="resourceLogDatasource">
                    <ng-container matColumnDef="image_name">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ labels.IMAGE_NAME }}
                        </th>
                        <td mat-cell *matCellDef="let update">{{ update.image_name || "-"}}</td>
                    </ng-container>

                    <ng-container matColumnDef="exam_code">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ labels.EXAM_CODE }}
                        </th>
                        <td mat-cell *matCellDef="let update">{{ update.exam_code || "-" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ labels.STATUS }}
                        </th>
                        <td mat-cell *matCellDef="let update">
                            <mat-chip-set>
                                <mat-chip [ngClass]="getChipClass(update)">
                                    {{ getChipLabel(update) }}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="log">
                        <th mat-header-cell *matHeaderCellDef>
                            {{ labels.LOG }}
                        </th>
                        <td mat-cell *matCellDef="let update"><i class="fas fa-eye click-icon" (click)="openLog(update)"></i></td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let exam; columns: displayedColumns"
                    ></tr>
                </table>
            </div>
    
            <div class="exam-data" *ngIf="resourceStatus?.type === 'exam'">
                <div class="exam-exists">
                    <p class="image-present">{{ labels.EXAM_EXISTS }}</p>
                    <button mat-raised-button class="btn btn-primary refetch-ctrl" (click)="openExam(resourceStatus.exam_code)">Abrir exame</button>
                </div>

                <div class="present-images" *ngIf="resourceStatus?.images && resourceStatus?.images?.length">
                    <p>{{ labels.PRESENT_IMAGES }}</p>
                    <table
                    mat-table
                    [dataSource]="registeredImages">
                        <ng-container matColumnDef="image_name">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ labels.IMAGE_NAME }}
                            </th>
                            <td mat-cell *matCellDef="let image">{{ image.name || "-"}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="imageTableColumns"></tr>
                        <tr
                            mat-row
                            *matRowDef="let image; columns: imageTableColumns"
                        ></tr>
                    </table>
                </div>
                

                <div class="same-block-images" *ngIf="resourceStatus?.same_block_images && resourceStatus?.same_block_images?.length">
                    <p>{{ labels.SAME_BLOCK_IMAGES }}</p>
                    <table
                    mat-table
                    [dataSource]="sameBlockImages">
                        <ng-container matColumnDef="image_name">
                            <th mat-header-cell *matHeaderCellDef>
                                {{ labels.IMAGE_NAME }}
                            </th>
                            <td mat-cell *matCellDef="let image">{{ image.name || "-"}}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="imageTableColumns"></tr>
                        <tr
                            mat-row
                            *matRowDef="let image; columns: imageTableColumns"
                        ></tr>
                    </table>
                </div>
                
            </div>
        </div>
    </div>

    <div class="toggle-full-list">
        <span>{{ labels.SHOW_FULL_LOG }}</span>
        <i class="fas fa-chevron-up toggle-btn" *ngIf="fullLogShown" (click)="hideFullLog()"></i>
        <i class="fas fa-chevron-down toggle-btn" *ngIf="!fullLogShown" (click)="displayFullLog()"></i>
    </div>

    <div class="hide-content" *ngIf="fullLogShown">
        <div
        class="list-container"
        *ngIf="logList && logList.length > 0; else emptyCase"
        >
            <div class="top-bar">
                
                <div class="commands">
                    <i class="fas fa-magnifying-glass search"></i>
                    <input type="text" class="form-control" [(ngModel)]="filterText" (input)="filterList()"/>
                </div>

                
                <button mat-raised-button class="btn btn-primary refetch-ctrl">
                    <i class="fas fa-rotate" (click)="fetchLog()"></i>
                    {{ labels.RELOAD_LIST }}
                </button>
            </div>

            <table
            mat-table
            [dataSource]="dataSource">
                <ng-container matColumnDef="image_name">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ labels.IMAGE_NAME }}
                    </th>
                    <td mat-cell *matCellDef="let update">{{ update.image_name || "-"}}</td>
                </ng-container>

                <ng-container matColumnDef="exam_code">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ labels.EXAM_CODE }}
                    </th>
                    <td mat-cell *matCellDef="let update">{{ update.exam_code || "-" }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ labels.STATUS }}
                    </th>
                    <td mat-cell *matCellDef="let update">
                        <mat-chip-set>
                            <mat-chip [ngClass]="getChipClass(update)">
                                {{ getChipLabel(update) }}
                            </mat-chip>
                        </mat-chip-set>
                    </td>
                </ng-container>

                <ng-container matColumnDef="log">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ labels.LOG }}
                    </th>
                    <td mat-cell *matCellDef="let update"><i class="fas fa-eye click-icon" (click)="openLog(update)"></i></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let exam; columns: displayedColumns"
                ></tr>
            </table>

            <span class="paginator-container" *ngIf="pageSize < count">
                <mat-paginator
                    #paginator
                    class="paginator"
                    (page)="handlePageEvent($event)"
                    [length]="count"
                    [pageSize]="pageSize"
                    [showFirstLastButtons]="showFirstLastButtons"
                    [pageSizeOptions]="[]"
                    [hidePageSize]="hidePageSize"
                    [pageIndex]="pageIndex"
                    aria-label="labels_paginators.PAGINATOR"
                >
                </mat-paginator>
            </span>

        </div>
    </div>
</div>

<ng-template #emptyCase>
    <div class="spinner-container" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loading">
      {{ labels.NODATA }}
    </div>
</ng-template>